import { openDialog } from '@component/dialog';
import wemeetClient from '@utils/wemeetClient';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useRtcErrorListener = () => {
  const { t } = useTranslation();
  useEffect(() => {
    const rtcError = wemeetClient.onRtcError((error) => {
      console.log(error);
      // TODO sentry 上报错误信息
      /**
       * Sentry.captureMessage(`${getServerUserInfoState('nickName')} rtc报错${JSON.stringify(data)}`);
      if (code === 16449) {
        // 重点关注这个
        Sentry.captureMessage(`重点：${getServerUserInfoState('nickName')} rtc报错：${JSON.stringify(data)}`);
      }
       */
      const code = error.getCode();
      openDialog({
        dialogId: 'trtcError',
        title: t('发生异常'),
        content: t('会议发生异常(错误码:{#code#})，请重新加入会议。', { code }),
        onOk: () => {
          window.location.reload();
        },
      });
    });
    return () => {
      wemeetClient.removeListener(rtcError);
    };
  }, []);
};
